import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Loader2 } from 'lucide-react';
import {
  BrandCreatorPrices,
  getBrandCreatorSetting,
  setBrandCreatorPrices,
} from '../../api/payment/brand-deal.api';

const errorMessage = (err: unknown, fallback: string) =>
  (err as { response?: { data?: { message?: string } } })?.response?.data?.message || fallback;

// Ô trống = không bán kiểu đó.
const toNum = (s: string): number | null => {
  const v = s.replace(/\D/g, '');
  return v ? Number(v) : null;
};
const toText = (n?: number | null) => (n ? String(n) : '');

const BrandLiveRateCardForm: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [post, setPost] = useState('');
  const [monthly, setMonthly] = useState('');
  const [hours, setHours] = useState('');
  const [hourly, setHourly] = useState('');

  useEffect(() => {
    getBrandCreatorSetting()
      .then((s) => {
        setPost(toText(s.postPriceVnd));
        setMonthly(toText(s.liveMonthlyPriceVnd));
        setHours(toText(s.liveMonthlyHours));
        setHourly(toText(s.liveHourlyPriceVnd));
      })
      .catch((err) => toast.error(errorMessage(err, 'Không tải được bảng giá.')))
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    const body: BrandCreatorPrices = {
      postPriceVnd: toNum(post),
      liveMonthlyPriceVnd: toNum(monthly),
      liveMonthlyHours: toNum(hours),
      liveHourlyPriceVnd: toNum(hourly),
    };
    setSaving(true);
    try {
      await setBrandCreatorPrices(body);
      toast.success('Đã lưu bảng giá.');
    } catch (err) {
      toast.error(errorMessage(err, 'Không lưu được bảng giá.'));
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="ui-card flex justify-center p-6">
        <Loader2 className="animate-spin ui-muted" />
      </div>
    );
  }

  const field = (label: string, value: string, set: (v: string) => void, unit: string) => (
    <label className="flex flex-col gap-1">
      <span className="ui-muted text-[13px]">{label}</span>
      <div className="flex items-center gap-2">
        <input
          className="ui-input w-full px-3 py-2 text-[14px]"
          inputMode="numeric"
          value={value}
          onChange={(e) => set(e.target.value.replace(/\D/g, ''))}
          placeholder="Để trống nếu không bán"
        />
        <span className="ui-muted shrink-0 text-[13px]">{unit}</span>
      </div>
    </label>
  );

  return (
    <div className="ui-card flex flex-col gap-3 p-4">
      <div>
        <div className="ui-heading text-[15px] font-bold">Bảng giá</div>
        <p className="ui-muted text-[13px]">
          Giá doanh nghiệp thấy khi đặt quảng cáo trên kênh của bạn. Ô nào để trống thì bạn không bán kiểu đó.
        </p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {field('Giá một bài đăng', post, setPost, 'đ')}
        {field('Giá hiển thị cả tháng (gói tháng)', monthly, setMonthly, 'đ')}
        {field('Số giờ livestream cam kết trong tháng', hours, setHours, 'giờ')}
        {field('Giá mỗi giờ livestream (mua theo giờ)', hourly, setHourly, 'đ/giờ')}
      </div>
      <div>
        <button
          type="button"
          disabled={saving}
          onClick={save}
          className="rounded-lg bg-[#0057FF] px-4 py-2 text-[14px] font-semibold text-white disabled:opacity-60"
        >
          {saving ? 'Đang lưu...' : 'Lưu bảng giá'}
        </button>
      </div>
    </div>
  );
};

export default BrandLiveRateCardForm;
